/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
import Modal from 'react-responsive-modal';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import { AssignmentReturnedSharp } from "@material-ui/icons";

//import moment from "moment";

class PriceAgree3 extends Component {
  state = {
    agree: 'A',
    payWindowOpen: false,
  };
  componentDidMount = () => {
    window.addEventListener('message', this._payEnd);
  };
  componentWillUnmount = () => {
    window.removeEventListener('message', this._payEnd);
  };
  _payEnd = (e) => {
    const { setMemberShipPayEnd, setAgreeShow } = this.props;
    //const { freePassSerial } = this.state;
    //console.log(e)
    //if(e.data.type) {
    const callbackPart = e.data.callbackPart;
    const result = e.data.result;
    const orderCode = e.data.orderCode;

    //const me = this;
    //console.log(e.data)
    if (callbackPart === 'payment') {
      const gubun = e.data.gubun;
      if (gubun === 'auto') {
        if (result === 'success') {
          //toast.success('결제가 성공적으로 완료되었습니다.')
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });

          setTimeout(() => {
            setMemberShipPayEnd(true, orderCode);
          }, 500);

          setTimeout(() => {
            setAgreeShow(false);
          }, 800);
        } else if (result === '-1') {
          toast.error('결제하려는 이용권이 존재하지 않습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-2') {
          toast.error('잘못된 이용권 구매입니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-3') {
          toast.error('정기결제건이 존재합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error('해지 신청후 30일이후에 재신청이 가능합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error('사용중인 멤버십이 존재합니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else {
          toast.error('결제중 오류가 발생했습니다. 잠시후 다시 진행해 주세요.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          //오류페이지로...
        }
      } else {
        if (result === 'success') {
          //toast.success('결제가 성공적으로 완료되었습니다.')
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          setTimeout(() => {
            setMemberShipPayEnd(true, orderCode);
          }, 500);
        } else if (result === '-1') {
          toast.error('결제 정보가 누락되었습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-2') {
          toast.error(
            '멤버십 결제는 사용기간이 남아 있는경우 4번이상 연속구매가 불가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-3') {
          toast.error(
            '현재 멤버십을 보유하고 있습니다. 멤버십이 종료되는 시점부터 청소년 이용권 구매가 가능합니다.(청소년결제 종료)'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-4') {
          toast.error(
            '현재 청소년 이용권를 보유하고 있습니다.\n\n청소년 이용권이 종료되는 시점부터 멤버십 구매가 가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-10') {
          toast.error('결제금액이 맞지 않습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-11') {
          toast.error('포인트 아용액이 초과 되었습니다.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else if (result === '-20') {
          toast.error(
            '현재 정기결제 이용 고객으로  멤버십을 결제 할 수 없습니댜. 정기 결제 해지 후 결제가 가능합니다.'
          );
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
        } else {
          toast.error('결제중 오류가 발생했습니다. 잠시후 다시 진행해 주세요.');
          this.setState({
            payWindowOpen: false,
            payAlert: false,
          });
          //오류페이지로...
        }
      }
    }

    //} else {

    //}
  };
  _change = (e) => {
    this.setState({
      agree: e.target.value,
    });
  };
  _onAgree = async () => {
    //const { agree } = this.state;
    const { loginId } = this.props;

    const paymentUrl =
      'https://bill1.aniplustv.com/aniplus2020Api/PG/auto_payment_m_to_c.asp';
    const payType = 'C';
    const freePassSerial = 9;

    this.setState({
      payWindowOpen: true,
      payAlert: false,
      paymentUrl:
        paymentUrl +
        '?userid=' +
        loginId +
        '&freePassSerial=' +
        freePassSerial +
        '&payType=' +
        payType,
      //paymentUrl: 'https://bill1.aniplustv.com/aniplus2020Api/PG/auto.asp?userid=' + loginId + '&freePassSerial=' + freePassSerial + '&authId=' + authId
    });

    //setAgreeShow(false)

    /*
        if(agree === 'A' || agree === null || agree === undefined || agree === '') {
            toast.warn('변동가격의 정기결제 동의, 비동의를 선택해 주세요.')
        } else {
            const result = await this._onAgreeApi()
            const intReturn = result.data[0].intReturn;

            if(intReturn === 0) {
                if(agree === 'Y') {
                    toast.success('결제에 변경에 동의해 주셔서 대단히 감사드립니다.')
                  
                } else {
                    toast.success('정기결제가 정상 해지되었습니다. 감사합니다.')
                 
                }
                
            } else if(intReturn === -2) {
                toast.error('정기결제가 존재하지 않습니다.')
            } else if(intReturn === -1) {
                toast.error('이미 동의/비동의 절차를 진행하셨습니다.')
            }

            history.goBack()
            setAgreeShow(false)
        }
        */
  };
  _onAgreeApi = () => {
    const { apiUrl, loginId } = this.props;
    const { agree } = this.state;

    return axios
      .post(apiUrl + '/agreeOk', {
        params: {
          userid: loginId,
          agree: agree,
        },
      })
      .then((response) => response)
      .catch((error) => {
        alert('오류가 발생했습니다.');
      });
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onClose = () => {
    const { setAgreeShow } = this.props;
    setAgreeShow(false);
  };
  onCloseModal = () => {
    this.setState({
      payWindowOpen: false,
      paymentUrl: '',
    });
  };

  render() {
    const { payWindowOpen, paymentUrl } = this.state;
    const { infoData } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="cashcard_pop" style={{ zIndex: 100 }}>
          <div className="cashcard_pop_layer4">
            <div className="cashcard_close2">
              <a
                style={{ cursor: 'pointer', zIndex: 1100 }}
                onClick={this._onClose}
              >
                닫기
              </a>
            </div>

            <div className="cashcard_pop_card">
              <h1>
                <img src={imgUrl + '/img/cashcard/logo_img.png'} />
                휴대폰 정기결제 중지 알림
              </h1>

              <p style={{ lineHeight: 1.4, fontSize: 14 }}>
                이용하고 계시는 휴대폰 정기 결제 서비스는 PG사의 정책 변경으로
                인하여 서비스가 중단되었음을 알려드립니다.
                <br />
                <br />
                <span style={{ color: '#ff5d24', fontWeight: '800' }}>
                  지금 결제방식을 카드로 변경하시면
                  <br /> 남은 기간 + 1개월 무료 이용이 완료된 후 정기결제가
                  진행됩니다.
                </span>
                <br />
              </p>
              {/*
                                    <p style={{paddingBottom: 10}}>
                                        현 결제금액: <span style={{fontWeight: '800'}}>{this._CommaFormatted(infoData[0].price)}</span>원 => 변경된 결제금액 <span style={{fontWeight: '800', color: '#ff5d24'}}>12,900</span>원
                                    </p>
                                    */}
              {/*
                                    <ul className="radius1">
                                        <li>
                                            <div className="chek_group1">
                                                <span style={{color: '#ff5d24', fontSize: 11, fontWeight: '800' }}>변경된 금액으로 매월 정기결제 되는것에 동의하시겠습니까? </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="chek_group1">
                                                <input name="vod" id="checkbox_1" type="checkbox" value="Y" checked={agree === 'Y' ? true : false } className="checkbox_img" onChange={this._change}/><label htmlFor="checkbox_1">해지 후 카드결제 신청</label>
                                                <span style={{paddingLeft: 15}}></span>
                                                <input name="vod" id="checkbox_2" type="checkbox" value="N" checked={agree === 'N' ? true : false} className="checkbox_img" onChange={this._change}/><label htmlFor="checkbox_2">해지합니다.</label>
                                            
                                            </div>
                                        </li>
                                    </ul>
                                    */}
              <div className="cashcard_pop_line"></div>
              <p>
                변경 신청이 완료된 후{' '}
                <span style={{ color: '#ff5d24', fontWeight: '800' }}>
                  {infoData[0].nicName}
                </span>{' '}
                회원님의 다음 정기 결제일은{' '}
                <span style={{ color: '#ff5d24', fontWeight: '800' }}>
                  {infoData[0].rePayDate}
                </span>{' '}
                입니다.
                <br />
              </p>
              <p>
                만료일 이전에 변경신청을 하지 않으실 경우 정기 결제는 자동으로
                해지 되며, 이후 언제든 재결제가 가능합니다.
              </p>
              <p>
                본 화면은 정기결제 만료일 전까지 변경 신청을 하지 않으면 로그인
                후 계속 보여질 수 있습니다.
              </p>
            </div>
            <a
              style={{ cursor: 'pointer' }}
              onClick={this._onAgree}
              className="btn_a"
            >
              카드로 정기결제 변경 신청
            </a>
            {/*<a style={{ cursor: 'pointer'}} onClick={this._onAgree} className="btn_a">정기결제 해지하기</a>*?}
                                {/*<a style={{cursor: 'pointer'}} onClick={this._onSettingHide} className="btn_a" >취소</a>*/}
          </div>
        </div>

        <Modal
          open={payWindowOpen}
          onClose={this.onCloseModal}
          closeOnOverlayClick={false}
          closeOnEsc={true}
          center
        >
          <div style={{ width: 750, height: 750 }}>
            <div
              onClick={this.onCloseModal}
              style={{ cursor: 'pointer', zIndex: 10000000 }}
            >
              취소
            </div>
            <iframe
              src={paymentUrl ? paymentUrl : ''}
              frameBorder="0"
              scrolling="yes"
              style={{ border: 'none', width: 750, height: 700, marginTop: 50 }}
            ></iframe>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PriceAgree3));
